
export const ADD_REQUEST_DEMO_QUERY_DATA = 'ADD_REQUEST_DEMO_QUERY_DATA';
export const ADD_REQUEST_DEMO_QUERY_DATA_SUCCESS = 'ADD_REQUEST_DEMO_QUERY_DATA_SUCCESS';
export const ADD_REQUEST_DEMO_QUERY_DATA_FAILED = 'ADD_REQUEST_DEMO_QUERY_DATA_FAILED';

export const GET_REQUEST_DEMO_QUERY_DATA = 'GET_REQUEST_DEMO_QUERY_DATA';
export const GET_REQUEST_DEMO_QUERY_DATA_SUCCESS = 'GET_REQUEST_DEMO_QUERY_DATA_SUCCESS';
export const GET_REQUEST_DEMO_QUERY_DATA_FAILED = 'GET_REQUEST_DEMO_QUERY_DATA_FAILED'; 
